import { createUrl, restGet } from '~/src/dash/api/rest';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { maskOptionsForDemo } from '~/src/dash/apiV2/common';

export async function fetchSmallBidderGroupsOptionsList(
  publisherID: string,
): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/bidder_groups', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function fetchSmallBiddersOptionsList(publisherID: string): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/small_bidders', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function fetchSmallChannelsOptionsList(publisherID: string): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/small_sites', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function fetchSmallChannelGroupsOptionsList(
  publisherID: string,
): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/channel_groups', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export const generateChannelGroupsOptionsListV2 = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const shouldMaskLabel = checkUserInfoMasked(user.user);
  return fetchSmallChannelGroupsOptionsList(session.publisher.ID)
    .then((channelGroups) => {
      if (!shouldMaskLabel) {
        return channelGroups;
      }
      return maskOptionsForDemo(channelGroups, 'demo_channel_group');
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};

export const generateChannelsOptionsListV2 = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const shouldMaskLabel = checkUserInfoMasked(user.user);
  return fetchSmallChannelsOptionsList(session.publisher.ID)
    .then((channels) => {
      if (!shouldMaskLabel) {
        return channels;
      }
      return maskOptionsForDemo(channels, 'demo_channel');
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};

export async function getCreativeValidationUsersByPublisherOptionsList(
  publisherID: string,
  reviewStatus: number,
): Promise<ISelectOption[]> {
  const reqUrl = createUrl(
    `/ui_options/creative_validation_users/${reviewStatus}`,
    publisherID,
    'v1',
  );
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function getCreativeValidationAdomainsByPublisherOptionsList(
  publisherID: string,
  reviewStatus: number,
): Promise<ISelectOption[]> {
  const reqUrl = createUrl(
    `/ui_options/creative_validation_adomains/${reviewStatus}`,
    publisherID,
    'v1',
  );
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function fetchDealOptionList(publisherID: string): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/deals', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export const generateDealOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const shouldMaskLabel = checkUserInfoMasked(user.user);
  return fetchDealOptionList(session.publisher.ID)
    .then((deals) => {
      if (!shouldMaskLabel) {
        return deals;
      }
      return maskOptionsForDemo(deals, 'demo_deal');
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};
